import type { ReactNode } from 'react'

import cn from 'clsx'

import { ShareIcon } from '@ds/components'

import styles from './HeroMobileControls.module.css'

type THeroMobileControlsProps = {
    shareLabel: string
    onShare: () => void
    playSlot: ReactNode
    /** Third column: the like button for a visitor, the edit trigger for the owner. */
    trailingSlot: ReactNode
}

export const HeroMobileControls = ({
    shareLabel,
    onShare,
    playSlot,
    trailingSlot,
}: THeroMobileControlsProps) => (
    <div className={styles.controls}>
        <button
            type="button"
            className={cn(styles.iconButton, styles.share)}
            aria-label={shareLabel}
            onClick={onShare}
        >
            <ShareIcon className={styles.icon} width={32} height={32} />
        </button>
        {playSlot}
        <div className={styles.trailing}>{trailingSlot}</div>
    </div>
)
